import {Component, Inject, signal} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarLabel,} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {TranslocoPipe} from '@jsverse/transloco';
import {SnackbarService} from 'services/snackbar/snackbar.service';

export enum OperationStatus {
  SUCCESS,
  ERROR,
}

export type OperationInformation =
  | {
  status: OperationStatus.ERROR;
  message: string;
  reason: string;
  url?: string;
  closable?: boolean;
}
  | {
  status: OperationStatus.SUCCESS;
  message: string;
  url?: string;
  closable?: boolean;
};

@Component({
  selector: 'app-operation-snackbar',
  imports: [
    MatCardModule,
    MatIconModule,
    MatSnackBarLabel,
    MatSnackBarAction,
    MatButtonModule,
    TranslocoPipe,
  ],
  templateUrl: './operation-snackbar.component.html',
  styleUrl: './operation-snackbar.component.css',
})
export class OperationSnackbarComponent {
  readonly operationInfo = signal({} as OperationInformation);
  protected readonly OperationStatus = OperationStatus;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: OperationInformation,
    private readonly snackbarService: SnackbarService,
  ) {
    this.operationInfo.set(data);
  }

  isArray(variable: unknown): boolean {
    return Array.isArray(variable);
  }

  closeModal() {
    this.snackbarService.close();
  }
}
